// Libs
import { useEffect } from 'react';
// Components, Layouts, Pages
// Others
// Styles, images, icons

type Props = {
  containerId: string;
  onNotScrollable: () => void;
};

const useCheckScrollable = (props: Props) => {
  //#region Destructuring Props
  const { containerId, onNotScrollable } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    const checkContentHeight = () => {
      const content = document.getElementById(containerId);
      if (content && content.scrollHeight <= content.clientHeight) {
        onNotScrollable();
      }
    };

    checkContentHeight();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function
};

export default useCheckScrollable;
